import { render, staticRenderFns } from "./DiseaseAreaCountMapComponent.vue?vue&type=template&id=32fdd4fd&"
import script from "./DiseaseAreaCountMapComponent.vue?vue&type=script&lang=js&"
export * from "./DiseaseAreaCountMapComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports